import { CardActionArea as MuiCardActionArea, Grid as MuiGrid, Stack as MuiStack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { ListActionVariant, StyledCardMedia } from "@framework/styled";
import type { IToken, IUser } from "@framework/types";
import { ContractAllowanceButton } from "@framework/shared";
import { Card, Typography } from "@dzambalaorg/ui-kit";
import { useUser } from "@dzambalaorg/provider-user";

import { RarityBadge } from "../../common/badge";

interface ITokenListItemProps {
  token: IToken;
  path: string;
}

export const TokenListItem = (props: ITokenListItemProps) => {
  const { token, path } = props;
  const { template } = token;

  const user = useUser<IUser>();
  const wallet = user.profile.wallet;

  const tokenBalance = token.balance?.filter(b => b.account === wallet);

  return (
    <MuiCardActionArea component={RouterLink} to={`${path}/${token.id}`}>
      <Card
        variant="outlined"
        header={
          <Card.Header
            subheader={
              <Typography variant="h5" color="textPrimary">
                {`${token.template!.title} #${token.tokenId}`}
              </Typography>
            }
            title={<StyledCardMedia image={token.template!.imageUrl} />}
          />
        }
      >
        <RarityBadge token={token} />
        <Card.Content>
          {tokenBalance && (
            <MuiStack direction="row" gap={2}>
              <Typography variant="body1" color="textSecondary">
                <FormattedMessage id="pages.token.balanceTitle" />
              </Typography>
              <Typography variant="body1" color="textSecondary">
                {tokenBalance.length ? tokenBalance[0].amount : 0}
              </Typography>
            </MuiStack>
          )}
        </Card.Content>

        <Card.Footer>
          <MuiGrid container alignItems="center">
            <MuiGrid size={{ xs: 12 }} display="flex" alignItems="center" gap={2}>
              {/*<OpenSeaSellButton token={token} />*/}
              {template?.contract && (
                <ContractAllowanceButton variant={ListActionVariant.button} contract={template.contract} />
              )}
            </MuiGrid>
          </MuiGrid>
        </Card.Footer>
      </Card>
    </MuiCardActionArea>
  );
};
